
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-now",
      function () {
        return require("private-next-pages/join-now.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-now"])
      });
    }
  